import React, { useState } from "react";
import { motion } from "motion/react";
import { Star, MessageCircle } from "lucide-react";
import ReviewCard from "../ui/ReviewCard";

export default function ExpertReviewsTab({
  expertReviews,
  averageRating,
  ratingDistribution,
  handleReplyToReview
}) {
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState("");

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <h2 className="text-2xl font-medium text-white">Отзывы</h2>

      <div className="p-6 rounded-2xl bg-neutral-900 border border-neutral-800">
        <div className="flex items-center gap-4 mb-6">
          <div className="text-center">
            <p className="text-4xl font-medium text-white">{averageRating > 0 ? averageRating : "—"}</p>
            <div className="flex items-center gap-1 mt-1">
              {[1, 2, 3, 4, 5].map((s) => (
                <Star
                  key={s}
                  className={`w-4 h-4 ${s <= Math.round(averageRating) ? "text-yellow-400 fill-yellow-400" : "text-neutral-600"}`}
                />
              ))}
            </div>
            <p className="text-lg font-extralight text-neutral-500 mt-1">{expertReviews.length} отзывов</p>
          </div>
          <div className="flex-1 space-y-1.5">
            {ratingDistribution.map((rd) => (
              <div key={rd.star} className="flex items-center gap-2">
                <span className="text-lg font-extralight text-neutral-400 w-4">{rd.star}</span>
                <Star className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400" />
                <div className="flex-1 h-2 bg-neutral-800 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-yellow-400 rounded-full transition-all"
                    style={{ width: `${rd.percentage}%` }}
                  />
                </div>
                <span className="text-lg font-extralight text-neutral-500 w-8 text-right">{rd.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="space-y-4">
        {expertReviews.length === 0 ? (
          <div className="text-center py-12">
            <MessageCircle className="w-10 h-10 text-neutral-700 mx-auto mb-3" />
            <p className="text-lg font-extralight text-neutral-500">Пока нет отзывов</p>
          </div>
        ) : (
          expertReviews.map((review) => (
            <div key={review.id} className="space-y-3">
              <ReviewCard review={review} />
              {!review.expertReply && (
                <div className="pl-4">
                  {replyingTo === review.id ? (
                    <div className="space-y-2">
                      <textarea
                        value={replyText}
                        onChange={(e) => setReplyText(e.target.value)}
                        rows={3}
                        className="w-full px-4 py-3 rounded-xl bg-neutral-800 border border-neutral-700 text-white text-lg font-extralight focus:outline-none focus:border-primary-500 resize-none"
                        placeholder="Ваш ответ на отзыв..."
                        autoFocus
                      />
                      <div className="flex gap-2">
                        <button
                          onClick={() => {
                            if (replyText.trim()) {
                              handleReplyToReview(review, replyText.trim());
                              setReplyingTo(null);
                              setReplyText("");
                            }
                          }}
                          className="px-4 py-2 rounded-lg bg-primary-600 hover:bg-primary-500 text-white text-lg font-extralight transition-colors"
                        >
                          Отправить
                        </button>
                        <button
                          onClick={() => { setReplyingTo(null); setReplyText(""); }}
                          className="px-4 py-2 rounded-lg hover:bg-neutral-700 text-neutral-400 hover:text-white text-lg font-extralight transition-colors"
                        >
                          Отмена
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button
                      onClick={() => setReplyingTo(review.id)}
                      className="flex items-center gap-2 text-primary-400 hover:text-primary-300 text-lg font-extralight transition-colors"
                    >
                      <MessageCircle className="w-4 h-4" />
                      Ответить
                    </button>
                  )}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </motion.div>
  );
}
